import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { addContactPersonAsync, getContactPersonByIdAsync, updateContactPersonAsync } from './contactPersonThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const clientSlice = createSlice({
    name: 'contactPerson',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addContactPersonAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(addContactPersonAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.contactPerson = action.payload;
        })
            .addCase(addContactPersonAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getContactPersonByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getContactPersonByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.contactPerson = action.payload;
        })
            .addCase(getContactPersonByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateContactPersonAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateContactPersonAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.contactPerson = action.payload;
        })
            .addCase(updateContactPersonAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default clientSlice.reducer;
